import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import FarmForm from "components/agro/farms/FarmForm";
import { createFarm } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const FarmCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const farm = {
    name: "",
    location: "",
    sizeM2: "",
    averageAltitudeM: "",
    responsiblePersonId: "",
    photoEvidence: "",
    blueprints: "",
    description: "",
    companyID: me?.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        location,
        description,
        companyID,
        sizeM2,
        averageAltitudeM,
        responsiblePersonId,
        photoEvidence,
        blueprints,
      } = valuesParam;

      await API.graphql({
        query: createFarm.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            location,
            description,
            companyID,
            sizeM2:
              sizeM2 === undefined || sizeM2 === "" ? null : Number(sizeM2),
            averageAltitudeM:
              averageAltitudeM === undefined || averageAltitudeM === ""
                ? null
                : Number(averageAltitudeM),
            responsiblePersonId,
            photoEvidence,
            blueprints,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/agro/farms");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <FarmForm onSubmit={onSubmit} initialValues={farm} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Finca",
    successAdded: "Finca agregada con éxito",
    responses: {},
  },
});

export default FarmCreateForm;
